<template>
  <gift-handover-gate
    page="gift-review-audits"
    title="審核管理"
    :links="exportLinks"
  >
    <section>
      <review-list :query="query" mode="review" />
    </section>
  </gift-handover-gate>
</template>

<script>
import GiftHandoverGate from '@/components/gifts/GiftHandoverGate'
import ReviewList from '@/components/gifts/ReviewList'

export default {
  name: 'Reviews',
  components: { GiftHandoverGate, ReviewList },

  data() {
    const { query } = this.$route

    return {
      query: query,
      exportLinks: [{ page: 'gift-review-exports', title: '匯出紀錄' }]
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
